// Assessment routes
import AssessmentList from '../../components/Assessment.vue'
import AssessmentOptions from '../../components/AssessmentOptions.vue'
import CreateAssessmentOption from '../../components/CreateAssessmentOption.vue'
import AssessmentParts from '../../components/AssessmentParts.vue'
import AssessmentView from '../../views/AssessmentView.vue'
import AssessmentQuestions from '../../components/AssessmentQuestions.vue'
import TestEditor from '../../views/TestEditor.vue'

export default [
  {
    path: '/assessments',
    name: 'Assessments',
    component: AssessmentList,
    meta: { 
      requiresAuth: true,
      title: 'Assessments'
    }
  },
  {
    path: '/assessment-options',
    name: 'AssessmentOptions',
    component: AssessmentOptions,
    meta: { 
      requiresAuth: true,
      title: 'Assessment Options'
    }
  },
  {
    path: '/assessment-options/create',
    name: 'CreateAssessmentOption',
    component: CreateAssessmentOption,
    meta: { 
      requiresAuth: true,
      title: 'Create Assessment Option'
    }
  },
  {
    path: '/assessment-parts',
    name: 'AssessmentParts',
    component: AssessmentParts,
    meta: { 
      requiresAuth: true,
      title: 'Assessment Parts'
    }
  },
  {
    path: '/assessment-view',
    name: 'AssessmentView',
    component: AssessmentView,
    meta: { 
      requiresAuth: true,
      title: 'Assessment View'
    }
  },
  {
    path: '/assessment-questions',
    name: 'AssessmentQuestions',
    component: AssessmentQuestions,
    meta: { 
      requiresAuth: true,
      title: 'Assessment Questions'
    }
  },
  {
    path: '/test-editor',
    name: 'TestEditor',
    component: TestEditor,
    meta: {
      requiresAuth: true,
      title: 'Test Editor'
    }
  }
] 